import PaidSubscriptionContent from "../content/paidSubscriptionContent";
import Layout from "../layout/Layout";

export default function PaidSubscription() {
  return (
    <Layout>
      <PaidSubscriptionContent />
    </Layout>
  );
}
